
import { Col, Row } from "reactstrap";
import React from "react";
import Todos from "./todos";
// import Bags from "./bagsDash";
import CaseFiles from "./caseFiles";

const Home = () => {

    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    {/* <Bags /> */}
                    <CaseFiles isDashboard={true} />
                </Col>
                <Col xs={12} style={{maxHeight:'50vh'}}>
                    <Todos />
                </Col>
            </Row>
        </React.Fragment>
        
    )
    
}

export default Home;

